<template lang="pug">
#sub-empresa-bloco-dados-contrato-originacao
    h2.mb-3.mt-3 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.titulo') }}
    el-card(shadow='never', :body-style='{ padding: "16px" }')
        .bloco-dados-contrato-originacao__linha
            .bloco-dados-contrato-originacao-informacao
                .bloco-dados-contrato-originacao-codigo-externo
                    h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.codigoExterno') }}
                    el-tooltip(v-if='dados.codigoExterno', placement='top')
                        .codigo-externo--tooltip(slot='content') {{ tooltipCopiarCodigo }}
                        i.mdi.mdi-content-copy(
                            @click='copiarCodigoParaAreaTransferencia(dados.codigoExterno)'
                        )
                    i.el-icon-edit(@click='atualizarModalCodigoExterno(true)')
                p.codigo-externo--minificado {{ dados.codigoExterno ? dados.codigoExterno : '--' }}
            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.numeroContrato') }}
                p {{ dados?.numeroContrato ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.cultura') }}
                p {{ dados?.materialNome ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.safraAR') }}
                p {{ dados?.safraNome ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.dataContrato') }}
                p {{ dados.dataCadastro || dados.dataContrato }}

        .bloco-dados-contrato-originacao__linha
            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.municipiosAr`) }}
                p {{ dados?.localidadeNivelUmNome ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.departamento`) }}
                p {{ dados?.localidadeNivelDoisNome ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.localidade`) }}
                p {{ dados?.localidadeNivelQuatroNome ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.condicaoFlete`) }}
                p {{ dados?.condicaoFrete ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.previsaoEntrega`) }}
                p {{ dados?.dataPrevistaEntrega ?? '--' }}

        .bloco-dados-contrato-originacao__linha
            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.estruturaComercial`) }}
                p {{ dados?.estruturaComercial ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.condicaoCliente`) }}
                p {{ dados?.condicaoCliente ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.plantaEntrega`) }}
                p {{ dados?.plantaEntregaBungeNome ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.vendedor`) }}
                p {{ dados?.vendedor ?? '--' }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t(`mensagens.subEmpresaGestao.blocodadoscontratooriginacao.cuitVendedor`) }}
                p {{ this.mascaraCuit(dados?.cuitVendedor) ?? '--' }}

        .bloco-dados-contrato-originacao__linha
            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeContratado') }}
                p {{ formatarVolume(dados?.volumeContratado) }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeAdicionado') }}
                p {{ formatarVolume(dados?.volumeInseridoTotal) }}

            .bloco-dados-contrato-originacao-informacao
                h4 {{ $t('mensagens.subEmpresaGestao.blocodadoscontratooriginacao.volumeRestante') }}
                p {{ formatarVolume(dados?.saldoRestante) }}

    div(v-if='modalCodigoExternoVisivel')
        BlocoInserirCodigoExterno(
            :dados='dados',
            :dialogVisible='modalCodigoExternoVisivel',
            @fechar='atualizarModalCodigoExterno'
        )
</template>

<script>
import BlocoInserirCodigoExterno from '@/components/contratosOriginacao/SubEmpresaBlocoInserirCodigoExterno.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'SubEmpresaBlocoDadosVisualizarContratoOriginacao',
    components: {
        BlocoInserirCodigoExterno
    },

    props: {
        dados: {
            required: true,
            type: Object
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        ambienteLogadoPY() {
            return this.usuarioLogado.ambienteLogado === 'PY';
        }
    },

    data() {
        return {
            modalCodigoExternoVisivel: false,
            tooltipCopiarCodigo: 'Copie o código'
        };
    },

    methods: {
        copiarCodigoParaAreaTransferencia() {
            this.tooltipCopiarCodigo = 'Copiado';
            navigator.clipboard
                .writeText(this.dados.codigoExterno)
                .then(() => {
                    setTimeout(() => {
                        this.tooltipCopiarCodigo = 'Copie o código';
                    }, 1000);
                })
                .catch(function (error) {
                    // eslint-disable-next-line no-console
                    console.error('Erro ao copiar o texto: ', error);
                });
        },

        atualizarModalCodigoExterno(value) {
            this.modalCodigoExternoVisivel = value;
        },

        formatarVolume(value) {
            if (value == null) { return '--'; }
            return value.toString().replace('.', ',');
        },

        mascaraCuit(cuit) {
            if (cuit === null || typeof cuit === 'undefined') {
                return ''; // Ou qualquer outro valor padrão que faça sentido (ex: 'N/A')
            }
            let formattedValue = String(cuit);
            const apenasNumeros = formattedValue.replace(/\D/g, '');
            const formato = apenasNumeros.replace(
                /^(\d{2})(\d{8})(\d{1})$/,
                '$1-$2-$3'
            );

            return formato;
        }
    }
};
</script>

<style lang="scss" scoped>
#sub-empresa-bloco-dados-contrato-originacao {
    .mb-3 {
        font-weight: bold;
        margin-bottom: 20px;
    }
    .bloco-dados-contrato-originacao__linha {
        display: grid;
        grid-template-columns: repeat(5, 1fr);

        h4 {
            font-weight: bold;
            color: var(--primary);
        }
    }

    .bloco-dados-contrato-originacao-codigo-externo {
        display: flex;
        align-items: center;
        gap: 5px;

        i {
            cursor: pointer;
        }

        i:hover {
            color: var(--primary);
            font-weight: bold;
        }
    }

    .bloco-dados-contrato-originacao-informacao {
        min-width: 155px;

        .codigo-externo--minificado {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        p {
            word-break: break-all;
            width: 100%;
        }
    }
    .el-card.codigo-externo.is-never-shadow {
        margin-top: 4px;
    }
}
.codigo-externo--tooltip {
    width: 90px;
    text-align: center;
}
</style>
